import React, { Fragment, useCallback } from 'react'

import DynamicField from './DynamicField'
import { SectionSubtitle } from '../..'
import { FormActions } from '../../../context/ProfileFormController'
import { FormFieldItem, FormFields } from '../../../types'
import { Spacer } from '../../global'
import { DoubleCol, MultipleCols } from '../styles'

type Props = {
  fields: FormFields[]
  formActions: FormActions
  isDisabled?: boolean
}

const SectionFields = ({ fields, formActions, isDisabled = false }: Props) => {
  const renderItems = useCallback(
    (items?: FormFieldItem[]) =>
      items?.map((item) => (
        <DynamicField
          key={item.id}
          item={item}
          fieldFn={formActions}
          disabled={!isDisabled}
        />
      )),
    [formActions, isDisabled],
  )

  const renderRows = (field: FormFields) => (
    <>
      {renderItems(field.rowLeft)}
      {renderItems(field.rowRight)}
    </>
  )

  const renderLayout = (field: FormFields) => {
    if (field.type === 'doubleColums') {
      return (
        <DoubleCol>
          <div className="col">{renderItems(field.rowLeft)}</div>
          <div className="col">{renderItems(field.rowRight)}</div>
        </DoubleCol>
      )
    }

    if (field.type === 'multipleColumns') {
      return <MultipleCols>{renderRows(field)}</MultipleCols>
    }

    return renderRows(field)
  }

  // return (
  //   <>
  //     {fields.map((field, i) => (
  //       <span key={i}>
  //         <Spacer height={30} />
  //         <SectionSubtitle fontWeight={500} fontSize={16} lineHeight={21}>
  //           {field.title}
  //         </SectionSubtitle>
  //         <Spacer height={16} />
  //         {field.subtitle && (
  //           <SectionSubtitle fontWeight={500} fontSize={14} lineHeight={21}>
  //             {field.subtitle}
  //           </SectionSubtitle>
  //         )}
  //         {field.type === 'doubleColums' ? (
  //           <DoubleCol>
  //             <div className="col">
  //               {field.rowLeft?.map((item) => (
  //                 <DynamicField
  //                   item={item}
  //                   fieldFn={formActions}
  //                   disabled={!isDisabled}
  //                   key={item.id}
  //                 />
  //               ))}
  //             </div>
  //             <div className="col">
  //               {field.rowRight?.map((item) => (
  //                 <DynamicField
  //                   item={item}
  //                   fieldFn={formActions}
  //                   disabled={!isDisabled}
  //                   key={item.id}
  //                 />
  //               ))}
  //             </div>
  //           </DoubleCol>
  //         ) : field.type === 'multipleColumns' ? (
  //           <MultipleCols>
  //             {field.rowLeft?.map((item) => (
  //               <DynamicField
  //                 item={item}
  //                 fieldFn={formActions}
  //                 disabled={!isDisabled}
  //                 key={item.id}
  //               />
  //             ))}
  //             {field.rowRight?.map((item) => (
  //               <DynamicField
  //                 item={item}
  //                 fieldFn={formActions}
  //                 disabled={!isDisabled}
  //                 key={item.id}
  //               />
  //             ))}
  //           </MultipleCols>
  //         ) : (
  //           <>
  //             {field.rowLeft?.map((item) => (
  //               <DynamicField
  //                 item={item}
  //                 fieldFn={formActions}
  //                 disabled={!isDisabled}
  //                 key={item.id}
  //               />
  //             ))}
  //             {field.rowRight?.map((item) => (
  //               <DynamicField
  //                 item={item}
  //                 fieldFn={formActions}
  //                 disabled={!isDisabled}
  //                 key={item.id}
  //               />
  //             ))}
  //           </>
  //         )}
  //       </span>
  //     ))}
  //   </>
  // )
  return (
    <>
      {fields.map((field) => (
        <Fragment key={field.title}>
          <Spacer height={30} />
          <SectionSubtitle fontWeight={500} fontSize={16} lineHeight={21}>
            {field.title}
          </SectionSubtitle>

          {field.subtitle && (
            <>
              <Spacer height={16} />
              <SectionSubtitle fontWeight={500} fontSize={14} lineHeight={21}>
                {field.subtitle}
              </SectionSubtitle>
            </>
          )}

          <Spacer height={16} />
          {renderLayout(field)}
        </Fragment>
      ))}
    </>
  )
}

export default SectionFields
